import { scroller } from "react-scroll";
import { Button } from "@mui/material";

const BecomeDealerButton = () => {
  // Scroll to Become dealer form
  const scrollToDealerForm = () => {
    scroller.scrollTo("becomeDealerSection", {
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{ mb: { xs: 2, md: 4 }, width: { xs: "100%", md: 222 } }}
        onClick={scrollToDealerForm}
      >
        Become an installer
      </Button>      
    </>
  );
};

export default BecomeDealerButton;
